var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFreePlan = function SvgFreePlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#free-plan_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2.09c-4.244 6.785-1.853 21.59 4.34 26.933.565.487 1.4.383 1.811-.22 4.667-6.868 2.533-21.826-4.377-27.019-.584-.439-1.395-.3-1.774.306Z",
    fill: "url(#free-plan_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.01 29.314c0 1.375 1.376 6.417 1.376 7.792",
    stroke: "url(#free-plan_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.345 29.314c0 1.375-1.375 6.417-1.375 7.792",
    stroke: "url(#free-plan_svg__d)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#free-plan_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.372 29.8c2.81-5.06.005-16.357-8.153-15.21 1.496.652 0 9.82 8.153 15.21Z",
    fill: "url(#free-plan_svg__f)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#free-plan_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.372 29.8c6.68-7.416 1.931-15.21 3.765-17.772-12.76 1.361-8.37 13.697-3.765 17.772Z",
    fill: "url(#free-plan_svg__h)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.576 6.265c-6.8 4.497-11.027 17.534-7.676 24.6.313.659 1.13.877 1.774.484 7.224-4.415 11.753-17.488 7.68-24.693-.352-.622-1.161-.8-1.778-.391Z",
    fill: "url(#free-plan_svg__i)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#free-plan_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.52 31.969c4.75-3.587 8.335-17.945.367-19.941 1.09 1.157-5.783 12.394-.367 19.94Z",
    fill: "url(#free-plan_svg__k)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#free-plan_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.52 31.969c9.31-4.3 8.03-13.02 11.843-14.719-12.275-3.516-14.31 9.266-11.843 14.719Z",
    fill: "url(#free-plan_svg__m)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "free-plan_svg__b",
    x1: 8.968,
    y1: 1.449,
    x2: 13.027,
    y2: 29.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EF5E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#D43C08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "free-plan_svg__c",
    x1: 13.698,
    y1: 29.314,
    x2: 13.698,
    y2: 37.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#267512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27940C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "free-plan_svg__d",
    x1: 19.657,
    y1: 29.314,
    x2: 19.657,
    y2: 37.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#267512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27940C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "free-plan_svg__f",
    x1: 5.885,
    y1: 11.861,
    x2: 12.322,
    y2: 30.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#62B745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "free-plan_svg__h",
    x1: 14.353,
    y1: 10.486,
    x2: 13.351,
    y2: 30.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#62B745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "free-plan_svg__i",
    x1: 27.5,
    y1: 5.957,
    x2: 20.91,
    y2: 32.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EF5E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#D43C08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "free-plan_svg__k",
    x1: 20.38,
    y1: 12.738,
    x2: 19.337,
    y2: 32.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8FFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#62B745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "free-plan_svg__m",
    x1: 28.73,
    y1: 14.641,
    x2: 20.26,
    y2: 32.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#62B745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376726"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "free-plan_svg__e",
    x: 3.719,
    y: 13.008,
    width: 12.212,
    height: 18.292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4402_7362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4402_7362",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "free-plan_svg__g",
    x: 7.24,
    y: 10.528,
    width: 10.396,
    height: 19.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4402_7362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4402_7362",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "free-plan_svg__j",
    x: 15.914,
    y: 10.528,
    width: 10.169,
    height: 22.941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4402_7362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4402_7362",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "free-plan_svg__l",
    x: 17.101,
    y: 15.148,
    width: 14.763,
    height: 17.321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4402_7362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4402_7362",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "free-plan_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .957)",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgFreePlan;